export enum CashRegisterMode {
    RESTAURANT = 0,
    RETAIL = 1
}
